import Image from 'next/image';

interface ArtistProps {
  src: string;
  alt: string;
  titleSrc?: string;
  className?: string;
  width?: number | string;
  height?: number | string;
}

const Artist = ({ src, alt, titleSrc, className, width = 140, height = 'auto' }: ArtistProps) => {
  return (
    <div className={`relative group ${className}`}>
      <div className="relative w-full h-full z-10 flex flex-col items-center
                   transition-transform duration-500 group-hover:scale-105">
        {/* Artist Image Container - fixed width để đảm bảo tất cả artist có cùng kích thước */}
        <div
          className="flex items-center justify-center bg-transparent overflow-hidden"
          style={{
            width: `${width}`,
            height: `${height}`
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: width,
              maxHeight: height,
              objectFit: 'contain',
              objectPosition: 'center',
              width: width,
              height
            }}
          />
        </div>

        {/* Artist Title Container - fixed width để align với image */}
        {titleSrc && (
          <div
            className="mt-2 flex items-center justify-center"
            style={{ width: `${width}px` }}
          >
            <img
              src={titleSrc}
              alt={`${alt} title`}
              style={{
                maxWidth: '100%',
                height: '30px',
                objectFit: 'contain',
                objectPosition: 'center'
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Artist;
